import options from './thing-owner.component';

export default {
    selector: 'dtAsThingOwner',
    options
};



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/search/advanced/thing-owner/index.js